export default {
    header: "Bestellingen van {name}",
    error: "Er is een fout opgetreden",
    empty: "Geen bestellingen gevonden",
    system: "Helpdesk",
    orders: {
        name: "Naam",
        date: "Datum",
        status: "Status",
        approvedBy: "Goedgekeurd door"
    },
    cta: {
        close: "Dichtbij"
    }
}